<template>
  <div class="news-style-browser">
    <div class="title">
      {{ $nippets.replace('newsPage.browseTheWork', 'gallery', gallery.name) }}
    </div>
    <div class="flex-browser">
      <div class="nav left" :class="{vizzy: loc > 0}" v-on:click="goLeft"></div>
      <div class="flex-mover" :class="{mleft: mleft, mright: mright, anim: anim}">
        <div class="flex-images" >
          <style-image v-for="item in currentData" :key="item.artist_id" :artistData="item" v-on:click="showZoomPortfolio(item)" />
        </div>
      </div>
      <div class="nav right" :class="{vizzy: loc < galleryData.length - cols}" v-on:click="goRight"></div>
    </div>
  </div>
</template>

<script>
import ViewablePanel from '@/mixins/ViewablePanel.js'
import StyleImage from '@/components/widgets/StyleImage.vue'
import '@/css/image-browser.css'
export default {
  components: {
    StyleImage
  },
  mixins: [ViewablePanel],
  data () {
    return {
      gallery: { name: 'not loaded'},
      loaded: false,
      galleryData: [],
      currentData: [],
      loc: 0,
      cols: 3,
      mounted: false,
      anim: false,
      mleft: false,
      mright: false
    }
  },
  mounted () {
    this.setCols()
    this.loaded = false
    if(this.inView) {
      if(!this.loaded) {
        this.loaded = true
        this.loadData()
      }
    }
    window.addEventListener('resize', this.setCols)
  },
  methods: {
    setCols () {
      let wd = window.innerWidth
      this.cols = 3
      if(wd > 1100) this.cols = 4
      if(wd > 1300) this.cols = 5;
      if(this.currentData.length > 0){
        this.currentData = this.galleryData.slice(this.loc, this.loc + this.cols)
      }
    },
    getRandomInt(max) {
      return Math.floor(Math.random() * Math.floor(max));
    },
    async init () {
      let galleries = await this.$store.dispatch('fetchGalleries')
      galleries = galleries.filter(el => (!el.animation && !el.redir))
      let rnd = this.getRandomInt(galleries.length)
      this.gallery = galleries[rnd]
    },
    async loadData () {
      await this.init()
      let gd = await this.$store.dispatch('fetchGalleryData', this.gallery.gallery_id)
      await this.$store.dispatch('fetchArtists')
      let artists = this.$store.getters.nonExcludedArtists.filter(el => el.artist_id)
      let lang = this.$store.state.lang.toLowerCase()
      artists = artists.filter(el => { return (el.region !== 'DE' || el.show_on_all) })
      artists = artists.filter(el => { return  !el.hiddens.includes(lang) })
      gd = gd.filter(el => artists.find(al => al.artist_id === el.artist_id))
      gd.sort((el, el1) => { return el.rnd - el1.rnd })
      this.galleryData = gd
      this.currentData = this.galleryData.slice(this.loc, this.loc + this.cols)
    },
    async showZoomPortfolio(data) {
      let artist = await this.$store.dispatch('fetchArtistById', data.artist_id)
      this.$ixr.push('/artists/' + artist.portfolio_url)
    },
    async goRight () {
      this.anim = true
      this.mleft = true
      await this.$k.waitfor(200)
      this.anim = false
      this.loc++
      this.currentData = this.galleryData.slice(this.loc, this.loc + this.cols)
      this.mleft = false
    },
    async goLeft () {
      this.anim = true
      this.mright = true
      await this.$k.waitfor(200)
      this.anim = false
      this.loc--
      this.currentData = this.galleryData.slice(this.loc, this.loc + this.cols)
      this.mright = false
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setCols)
  },
  watch: {
    inView () {
      if(this.inView) {
         if(!this.loaded) {
          this.loaded = true
          this.loadData()
        }
      }
    }
  }
}
</script>
